  <app-customer [formSubmitAttempted]="formState !== 'NEW'"
    (onValidChange)="customerDataValid = $event; checkValidity()"
    [addressEnabled]="displayCustomerAddress"
    [isMilesAndMoreCustomer]="isMilesAndMoreCustomer"
    [milesAndMoreServiceNumber]="milesAndMoreServiceNumber"
  ></app-customer>

  <app-object *ngIf="addressEnabled" [formSubmitAttempted]="formState !== 'NEW'"
              (onValidChange)="objectDataValid = $event; checkValidity()"></app-object>

  <h2>Ihre Nachricht</h2>

  <mat-form-field class="w-100" appearance="fill">
    <mat-label>Nachricht...</mat-label>
    <textarea rows="5" matInput name="remarks" [formControl]="remarkFormControl"></textarea>
    <mat-error *ngIf="remarkFormControl.invalid">Ihre Nachricht darf maximal 10.000 Zeichen lang sein</mat-error>
  </mat-form-field>

  <app-documents *ngIf="enableDocuments" (selectedFiles)="files.emit($event)"></app-documents>

  <input name="utm_source" [(ngModel)]="utmSource" class="hidden"/>

  <h3>Zustimmung:</h3>
  <mat-error *ngIf="formState !== 'NEW' && !consent.checked">Bitte bestätigen Sie ihre Zustimmung zur Datenübermittlung</mat-error>
  <mat-checkbox color="primary" #consent name="consent" #consentCheckbox (change)="onValidChange.emit(customerDataValid && consentCheckbox.checked)">
    Hiermit stimme ich der Übermittlung meiner Kontaktdaten an die Dr. Klein Privatkunden AG, Hansestr. 14, 23558 Lübeck,
    sowie an deren angebundene Franchise- und Vermittlungspartner zu. Zur weiteren Beratung per E-Mail oder Telefon willige ich ein.
  </mat-checkbox>

  <div class="comment">Vielen Dank für Ihre Eingaben, Sie können jetzt die Daten hier übermitteln</div>
  <div *ngIf="formState == 'SUBMIT_FAILED'" class="comment error-color">Bitte prüfen Sie ihre Eingaben</div>
  <div *ngIf="formState == 'SERVER_ERROR'" class="comment error-color">Es tut uns Leid, Ihre Anfrage kann zur Zeit leider nicht verarbeitet werden. Bitte versuchen Sie es später erneut.</div>
  <div class="w-100 text-center" >
  <button mat-flat-button color="primary" *ngIf="formState !== 'SENDING'">Jetzt absenden</button>
    <button mat-flat-button disabled="true" *ngIf="formState === 'SENDING'">
      <mat-spinner style="display: inline-block" diameter="16" ></mat-spinner>&nbsp;Formular wird verarbeitet ...
    </button>
  </div>
